// extracted by mini-css-extract-plugin
module.exports = {"partner-item":"partner-item","partnerItem":"partner-item"};